import * as React from 'react';
import styled from 'styled-components';

export const Footer: React.FC = ({ children }) => {
  return (
    <StyledFooter>
      <Credit>
        <span className="heading">Utvikling og drift av</span>
        <div className="reeltime">
          <ReeltimeLogo />
          <span>Reeltime</span>
        </div>
      </Credit>
    </StyledFooter>
  );
};

const StyledFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: 0 20px 0 0;
  width: calc(100% - 350px);
  height: 52px;
  float: left;
  background: white;
  border-top: solid 1px rgb(230, 230, 230);

  @-moz-document url-prefix() {
    width: 100%;
  }

  @media screen and (max-width: 800px) {
    width: 100%;
  }
`;

const Credit = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;

  span {
    &.heading {
      color: rgb(150, 150, 150);
      font-size: 12px;
    }
  }

  .reeltime {
    display: flex;
    svg {
      display: inline-block;
    }
    span {
      display: inline-block;
      margin-left: 5px;
    }
  }
`;

const ReeltimeLogo: React.FC = () => (
  <svg width="12px" length="auto" viewBox="0 0 192 237" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M18,236 L19,47 C19,47 19,18 52,18 C83,18 192,18 192,18"
        id="Path"
        stroke="#111"
        strokeWidth="35"
      ></path>
    </g>
  </svg>
);
